import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["calss", "draggable"]

import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import {
  reactive,
  inject,
  watch,
  onMounted,
  nextTick,
  ref,
  CSSProperties, 
  Ref,
} from 'vue'

type TSliderButtonInject = {
  vertical: boolean
  scales: number[]
  refs: {
    slider: Ref<HTMLDivElement>|{value: null}
  }
}

type TSliderButtonInitData = {
  dragging: boolean
  currentX: number | null
  currentY: number | null
  startX: number | null
  startY: number | null
  sliderSize: number | null
  style: CSSProperties
}


export default /*#__PURE__*/_defineComponent({
  props: {
  value: Number,
  disabled: Boolean,
},
  emits: [
  'update-inner-style',
  'input',
  'release',
  'dragStart',
  'dragEnd',
  'mouseEnter',
  'mouseLeave',
],
  setup(__props, { expose, emit }) {

const props = __props

const sliderButtonDefaultInject = {
  vertical: false,
  scales: [],
  refs: { slider: { value: null } },
}

const sliderButtonInitData = {
  dragging: false,
  currentX: null,
  currentY: null,
  startX: null,
  startY: null,
  sliderSize: null,
  style: {},
}

const slider = inject<TSliderButtonInject>('slider', sliderButtonDefaultInject)
const sliderRef = ref(slider)




const data = reactive<TSliderButtonInitData>(sliderButtonInitData)

const that = {
  isClick: false,
  dragging: false,
}

watch(() => props.value, () => {
  console.log('watch: props', props)
  setStyle(false)
})

const initPosition = () => {
  const sliderEle = slider.refs?.slider?.value
  if (sliderEle) {
    const rect = sliderEle.getBoundingClientRect()
    if (slider.vertical) {
      data.sliderSize = rect.height
      data.startY = rect.top + rect.height
    } else {
      data.sliderSize = rect.width
      data.startX = rect.left
    }
  }
}

const setStyle = (init: boolean) => {
  const _slider = slider
  const vertical = _slider.vertical
  const scales = _slider.scales
  const value = props.value
  let sliderSize = data.sliderSize as number

  if (value === undefined || value === null) {
    data.style = Object.assign({}, { [vertical ? 'bottom' : 'left']: 0 })
    return
  }

  if (sliderSize === null) {
    if (init) {
      // 初始化时不需要位置信息，可以使用默认位置信息
      sliderSize = 100
    } else {
      initPosition()
      sliderSize = data.sliderSize as number
    }
  }

  const blocks = scales.length - 1
  const blockSize = sliderSize / blocks
  let moved = 0
  let percent = '0%'
  let index = 1

  while (value > scales[index]) {
    moved += blockSize
    index++
  }
  moved += (value - scales[index - 1]) / (scales[index] - scales[index - 1]) * blockSize
  percent = moved / sliderSize * 100 + '%'
  data.style = Object.assign({}, { [vertical ? 'bottom' : 'left']: percent })
  emit('update-inner-style', percent)
}

const setValue = (isRelease = false) => {
  const currentY = data.currentY as number
  const currentX = data.currentX as number
  const scales = slider.scales
  let startX = data.startX as number
  let  startY = data.startY as number
  let sliderSize = data.sliderSize as number
  console.log('setValue', sliderSize)
  if (sliderSize === null || startX === null || startY === null) {
    initPosition()
    startX = data.startX as number
    startY = data.startY as number
    sliderSize = data.sliderSize as number
  }

  const blocks = scales.length - 1
  const blockSize = sliderSize / blocks
  let moved = 0

  if (slider.vertical) {
    moved = Math.max(Math.min(sliderSize, startY - currentY), 0)
  } else {
    moved = Math.max(Math.min(sliderSize, currentX - startX), 0)
  }

  let value = scales[0]
  let index = 1

  while (moved > blockSize) {
    moved -= blockSize
    value += scales[index] - scales[index - 1]
    index++
  }
  // 边界检查
  index = Math.min(index, scales.length - 1)
  // @ts-ignore
  value += parseInt(moved / blockSize * (scales[index] - scales[index - 1]))
  value = Math.min(scales[scales.length - 1], value)

  if (value !== props.value) {
    emit('input', value)
    if (isRelease) emit('release', value)
  }
}

const onDragging = (e) => {
  if (that.dragging) {
    e.preventDefault()
    that.isClick = false
    if (slider.vertical) {
      data.currentY = e.clientY
    } else {
      data.currentX = e.clientX
    }
    setValue()
  }
}

const onDraggingThrottle = throttle(onDragging, 16)

const onDragEnd = () => {
  if (that.dragging) {
    // 防止在 mouseup 后立即触发 click，导致触发clean
    // 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
    setTimeout(function () {
      that.dragging = false
      emit('dragEnd')
      if (!that.isClick) {
        setValue()
      }
    }, 0)
  }
  window.removeEventListener('mousemove', onDraggingThrottle)
  window.removeEventListener('mouseup', onDragEnd)
  window.removeEventListener('contextmenu', onDragEnd)
}

const onDragStart = (e) => {
  if (props.disabled) return

  emit('dragStart')
  const slider = sliderRef.value?.refs.slider
  if (!slider) return

  e.preventDefault()
  initPosition()

  data.dragging = true
  that.dragging = true
  that.isClick = true

  window.addEventListener('mousemove', onDraggingThrottle)
  window.addEventListener('mouseup', onDragEnd)
  window.addEventListener('contextmenu', onDragEnd)
}

const onMouseEnter = () => {
  emit('mouseEnter')
}

const onMouseLeave = () => {
  emit('mouseLeave')
}

const setSliderSize = (isSetStyle: boolean, isInit: boolean) => {
  nextTick(function nextTick () {
    const slider = sliderRef.value?.refs?.slider
    if (!slider) return
    if (!isInit) initPosition()
    isSetStyle && setStyle(isInit)
  })
}

const handleClick = (e) => {
  data.currentX = e.clientX
  data.currentY = e.clientY
  console.log('handleClick')
  setValue(true)
}

expose({ handleClick })

const setSliderSizeDebounce = debounce(setSliderSize, 60)

onMounted(() => {
  setSliderSize(true, true)
  window.addEventListener('resize', setSliderSizeDebounce)
  return () => window.removeEventListener('resize', setSliderSizeDebounce)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "td-slider__button",
    calss: __props.disabled ? 'is-disabled' : '',
    style: _normalizeStyle([_unref(data).style, _unref(slider).vertical ? { top: 'auto' } : '']),
    draggable: _unref(data).dragging,
    onMousedown: onDragStart,
    onMouseenter: onMouseEnter,
    onMouseleave: onMouseLeave,
    onClick: _cache[0] || (_cache[0] = e => e.stopPropagation())
  }, null, 44, _hoisted_1))
}
}

})